import { IProgramSetup } from 'shared/interfaces/IProgramSetup';

// The recording configuration shared by every program on a channel/station.
// Status and Sagap Process are per-program and live in the program drawer instead.
export interface IChannelRecording {
  machine: string;
  source: string;
  folder: string;
  ads: boolean;
}

export const SOURCE_FOLDER_ITEMS = [
  { id: 'HDMI', value: 'HDMI' },
  { id: 'TV', value: 'TV' },
  { id: 'RADIO', value: 'RADIO' },
  { id: 'Youtube', value: 'Youtube' },
];

export const TV_MACHINE_ITEMS = [
  'tv1',
  'tv2',
  'tv3',
  'tv4',
  'tv5',
  'KLTV1',
  'KLTV2',
  'KLTV3',
  'KLTV4',
  'KLTV5',
  'NASKL',
].map((value) => ({ id: value, value }));
export const RADIO_MACHINE_ITEMS = ['rad1', 'rad2', 'radio1', 'radio2', 'radio3', 'radio4'].map((value) => ({
  id: value,
  value,
}));

/**
 * Reads the channel-level recording config off one program on that channel. Every program
 * shares it, so any one of them is representative. Ads Automation is off unless it was
 * explicitly saved as on.
 */
export const getChannelRecording = (record?: IProgramSetup | null): IChannelRecording => ({
  machine: record?.local_recording_details?.local_recording_path || '',
  source: record?.local_recording_details?.source_folder || '',
  folder: record?.recording_title_setup?.folder_name || '',
  ads: record?.recording_title_setup?.ads_automation === true,
});
